import React, { Component } from "react";
import WithConsumer from '../../context/WithConsumer';

export default class PageText extends Component {
	
	render () {
		
		let block 		= this.props.block;
				
		if (block) {
									
		    return (
			    
			    <div data-id={block.id} className={'c-page__block c-page__block--load-effect'}>
			    
			    	<div className="l-content l-content--fixed-width">
			    		
			    		<div className="l-grid">
			    		
			    			<div className="l-grid__col">
			    				<div className="c-rule"></div>
			    			</div>
			    		
			    			<div className="l-grid__col l-grid__col--m-4-12 l-grid__col--l-6-12">
			    			
			    				<h2 className="c-paragraph c-paragraph--light" dangerouslySetInnerHTML={{__html:block.heading}}></h2>
			    				
			    			</div>
			    			
			    			<div className="l-grid__col l-grid__col--m-8-12 l-grid__col--l-6-12">
			    			
								<div className="scope-text" dangerouslySetInnerHTML={{__html:block.text}}></div>
								
							</div>
			    			
			    		</div>
			    		
			    	</div>
			    
			    </div>
			)
			
		} else {
			
			return null;
		
		}
	}
}
